module.exports = __webpack_public_path__ + "img/mp-citation-bg.bfa623ed.jpg";